import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IAidasUserAidasObjectMapping } from 'app/shared/model/ainnotateservice/aidas-user-aidas-object-mapping.model';
import { getEntities as getAidasUserAidasObjectMappings } from 'app/entities/ainnotateservice/aidas-user-aidas-object-mapping/aidas-user-aidas-object-mapping.reducer';


import { getEntity, updateEntity, createEntity, reset } from './aidas-upload.reducer';
import { IAidasUpload } from 'app/shared/model/ainnotateservice/aidas-upload.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasUploadUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const aidasUserAidasObjectMappings = useAppSelector(state => state.aidasUserAidasObjectMapping.entities);
  const aidasUploadEntity = useAppSelector(state => state.aidasUpload.entity);
  const loading = useAppSelector(state => state.aidasUpload.loading);
  const updating = useAppSelector(state => state.aidasUpload.updating);
  const updateSuccess = useAppSelector(state => state.aidasUpload.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-upload' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getAidasUserAidasObjectMappings({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.dateUploaded = convertDateTimeToServer(values.dateUploaded);
    values.statusModifiedDate = convertDateTimeToServer(values.statusModifiedDate);

    const entity = {
      ...aidasUploadEntity,
      ...values,
      aidasUserAidasObjectMapping: aidasUserAidasObjectMappings.find(
        it => it.id.toString() === values.aidasUserAidasObjectMappingId.toString()
      ),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          dateUploaded: displayDefaultDateTime(),
          statusModifiedDate: displayDefaultDateTime(),
        }
      : {
          ...aidasUploadEntity,
          dateUploaded: convertDateTimeFromServer(aidasUploadEntity.dateUploaded),
          statusModifiedDate: convertDateTimeFromServer(aidasUploadEntity.statusModifiedDate),
          aidasUserAidasObjectMappingId: aidasUploadEntity?.aidasUserAidasObjectMapping?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="ainnotategwApp.ainnotateserviceAidasUpload.home.createOrEditLabel" data-cy="AidasUploadCreateUpdateHeading">
            Create or edit a AidasUpload
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? <ValidatedField name="id" required readOnly id="aidas-upload-id" label="ID" validate={{ required: true }} /> : null}
              <ValidatedField
                label="Name"
                id="aidas-upload-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: 'This field is required.' },
                  minLength: { value: 3, message: 'This field is required to be at least 3 characters.' },
                  maxLength: { value: 500, message: 'This field cannot be longer than 500 characters.' },
                }}
              />
              <ValidatedField
                label="Date Uploaded"
                id="aidas-upload-dateUploaded"
                name="dateUploaded"
                data-cy="dateUploaded"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField label="Status" id="aidas-upload-status" name="status" data-cy="status" check type="checkbox" />
              <ValidatedField
                label="Status Modified Date"
                id="aidas-upload-statusModifiedDate"
                name="statusModifiedDate"
                data-cy="statusModifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField label="Reject Reason" id="aidas-upload-rejectReason" name="rejectReason" data-cy="rejectReason" type="text" />
              <ValidatedField
                id="aidas-upload-aidasUserAidasObjectMapping"
                name="aidasUserAidasObjectMappingId"
                data-cy="aidasUserAidasObjectMapping"
                label="Aidas User Aidas Object Mapping"
                type="select"
                required
              >
                <option value="" key="0" />
                {aidasUserAidasObjectMappings
                  ? aidasUserAidasObjectMappings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>This field is required.</FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/aidas-upload" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AidasUploadUpdate;
